import iconFacebook from "../images/iconFacebook.png";
import iconInstagram from "../images/iconInstagram.png";
export default function Footer() {
  return (
    <section className="mt-36 py-20 px-10  bg-purple-opacity text-white border-b-4 border-light-orange">
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-14 lg:gap-2 xl:w-[80%] xl:mx-auto">
        <div className="flex flex-col gap-4 ">
          <h3 className="font-bold text-xl">myFitness.</h3>
          <p>23, XYZ Street</p>
          <p>Contact : 075688629</p>
          <div className="flex flex-row gap-4 mt-4">
            <img src={iconFacebook} alt="FaceBook" />
            <img src={iconInstagram} alt="Instagram" />
          </div>
        </div>

        <div className="flex flex-col gap-4 ">
          <h3 className="font-bold text-xl">Company</h3>
          <ul className="flex flex-col gap-4 ">
            <li>Book Us</li>
            <li>About Us</li>
            <li>Book Trainers</li>
          </ul>
        </div>
        <div className="flex flex-col gap-4">
          <h3 className="font-bold text-xl">Legal</h3>
          <ul className="flex flex-col gap-4 ">
            <li>Privacy & Policy</li>
            <li>Terms & conditions</li>
            <li>Security & management</li>
          </ul>
        </div>

        <div className="flex flex-col gap-4 ">
          <h3 className="font-bold text-xl">Join Community</h3>
          <p>Get instant updates and challenge friends</p>
          <div className="relative">
            <input
              type="text"
              className="h-12 px-4 w-[100%]"
              placeholder="sample@gmail.com"
            />
            <button className="absolute top-0 right-0 px-8 py-3 bg-dark-blue uppercase">
              Send
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
